import { FCM_USE_DONATION_LANGUAGE } from '@change-corgi/config/fcm/configs';

import { createFcmContext } from 'src/app/shared/contexts/fcm';
import type { LoadedStateData } from 'src/app/shared/utils/async';

export const {
	FcmContext: PsfPromoteOrSharePageFcmContext,
	FcmProvider: PsfPromoteOrSharePageFcmContextProvider,
	useFcm: usePsfPromoteOrSharePageFcm,
	useAsyncFcm: useAsyncPsfPromoteOrSharePageFcm,
	prefetchFcm: prefetchPsfPromoteOrSharePageFcm,
} = createFcmContext({
	name: 'PsfPromoteOrSharePageFcmContext',
	dataProperty: 'pageFcm',
	configs: {
		useDonationLanguage: FCM_USE_DONATION_LANGUAGE,
	},
	prefetch: true,
});

export type PsfPromoteOrSharePageFcmState = ReturnType<typeof useAsyncPsfPromoteOrSharePageFcm>;
export type PsfPromoteOrSharePageFcm = LoadedStateData<PsfPromoteOrSharePageFcmState>;
